
import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Category } from "@/lib/types";

interface CategoryTooltipProps {
  category?: Category;
  children?: React.ReactNode;
}

export function CategoryTooltip({ category, children }: CategoryTooltipProps) {
  if (!category) {
    return <span>—</span>;
  }
  
  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>
          {children ? (
            children
          ) : (
            <span className="cursor-help">{category.name}</span>
          )}
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          {category.description || "No description available"}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
